import * as React from "react";
import Skeleton from "react-loading-skeleton";
export const SummaryShimmer = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "shimmer_skeleton" },
            React.createElement("div", { className: "summaryshimmer" },
                React.createElement(Skeleton, { height: 60, width: "100%", className: "align-top", count: props.count })))));
};
export const SummaryShimmerMob = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "shimmer_skeleton" },
            React.createElement("div", { className: "summaryshimmerMob" },
                React.createElement(Skeleton, { height: 60, width: "100%", className: "align-top", count: props.count })))));
};
